import { QUERY_shiftSummaryViewTeamMembers } from 'queries';
import { ShiftSummaryViewTeamMembersQueryVariables } from 'types/graphql';
import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';

export const shiftSummaryViewTeamMembersConfig = ({
  byJaneIds,
}: ShiftSummaryViewTeamMembersQueryVariables): ISSFBehaviorsOptions => {
  return {
    key: 'SHIFT-SUMMARY-VIEW_TEAM-MEMBERS',
    query: QUERY_shiftSummaryViewTeamMembers,
    schema: {
      byJaneIds: {
        initialValue: byJaneIds,
      },
    },
  };
};
